export default class RuleSetDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdBy: json.createdBy, modifiedBy: json.modifiedBy, createdDate: json.createdDate && new Date(json.createdDate), modifiedDate: json.modifiedDate && new Date(json.modifiedDate) });
    }
}
